import { Check, ArrowDown } from "lucide-react";
import { APP_INCLUDES, PLANS } from "../data/content";
import { Reveal } from "../components/Reveal";
import { scrollToTarget } from "../lib/scroll";

const Pricing = () => (
  <section id="planes" data-testid="rnb-pricing-section" className="relative py-20 lg:py-32 bg-zinc-100 border-y border-zinc-200 overflow-hidden">
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="text-center">
        <p className="text-xs tracking-[0.4em] text-zinc-500 uppercase">App RNB</p>
        <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl text-black leading-[0.95]">
          TU CAMINO AL CAMBIO REAL
        </h2>
        <p className="mt-4 text-base sm:text-lg text-zinc-600 font-light max-w-2xl mx-auto">
          App RNB: tu método de entrenamiento y nutrición, diseñado por mí y siempre en tu bolsillo.
        </p>
        <p className="mt-3 text-sm sm:text-base text-zinc-500 font-light max-w-2xl mx-auto">
          Estoy detrás de cada detalle del método: lo creo y lo reviso yo, y te acompaño a través de la app en cada paso.
        </p>
      </Reveal>

      <Reveal delay={0.15} className="mt-12">
        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-3 max-w-3xl mx-auto">
          {APP_INCLUDES.map((item) => (
            <li key={item} className="flex items-start gap-3 text-sm text-zinc-700">
              <Check className="h-4 w-4 mt-0.5 shrink-0 text-black" />
              {item}
            </li>
          ))}
        </ul>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6 items-stretch max-w-5xl mx-auto">
        {PLANS.map((plan, i) => (
          <Reveal key={plan.name} delay={0.1 + i * 0.1} className="h-full">
            <div
              data-testid={`rnb-pricing-card-${i + 1}`}
              className={`relative h-full flex flex-col p-8 transition-colors duration-300 ${
                plan.highlight
                  ? "bg-black text-white border border-black"
                  : "bg-white border border-zinc-300 hover:border-black"
              }`}
            >
              {plan.highlight && (
                <span className="absolute -top-3.5 left-1/2 -translate-x-1/2 bg-black text-white text-[10px] font-bold tracking-[0.25em] px-4 py-1.5 border border-white">
                  MEJOR PRECIO
                </span>
              )}
              <h3 className={`font-display text-2xl tracking-wider ${plan.highlight ? "text-white" : "text-black"}`}>{plan.name}</h3>
              <p className={`mt-5 font-display text-6xl leading-none ${plan.highlight ? "text-white" : "text-black"}`}>{plan.price}</p>
              <p className={`mt-3 text-xs ${plan.highlight ? "text-zinc-400" : "text-zinc-500"}`}>{plan.note}</p>
              <div className="flex-1" />
              <button
                disabled
                data-testid={`rnb-pricing-proximamente-${i + 1}`}
                className={`mt-8 w-full cursor-not-allowed font-display text-xl tracking-[0.2em] px-6 py-3.5 ${
                  plan.highlight
                    ? "bg-white text-black"
                    : "bg-black text-white"
                }`}
              >
                PRÓXIMAMENTE
              </button>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.3} className="mt-8 text-center">
        <p className="text-xs text-zinc-500 tracking-wide">La App RNB está en fase final de desarrollo. Los botones de compra se activarán en el lanzamiento.</p>
        <button
          onClick={() => scrollToTarget("#contacto")}
          data-testid="rnb-pricing-cta-notify"
          className="group mt-6 inline-flex items-center gap-3 border border-black text-black font-display text-xl tracking-[0.15em] px-8 py-4 hover:bg-black hover:text-white transition-colors"
        >
          QUIERO LA APP: AVÍSAME CUANDO ESTÉ LISTA
          <ArrowDown className="h-5 w-5 transition-transform duration-300 group-hover:translate-y-1" />
        </button>
      </Reveal>
    </div>
  </section>
);

export default Pricing;
